/**
 * @file Triggers a browser download of a file at a URL.
 */

/**
 * Downloads the file at the given URL by clicking a hidden link.
 */
const downloadFile = (url: string): void => {
  const link = document.createElement("a");

  link.setAttribute("target", "_blank");
  link.setAttribute("download", "");
  link.href = url;

  document.body.appendChild(link);

  link.click();
  link.remove();
};

export default downloadFile;
